import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'reader-core-position-indicator',
  templateUrl: './position-indicator.component.html',
  styleUrls: ['./position-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PositionIndicatorComponent {
  @Input() upper: number;
  @Input() lower: number;
}
